import Input from 'component/atom/forms/input/input/Input';
import { useFormikContext, FieldArray } from 'formik';
import React  from 'react';
import styles from './Form.module.scss';
import Select from 'component/atom/forms/select/select/Select';
import { workflow } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import { useParams } from 'react-router-dom';
import FormPreview from './formPreview/FormPreview';

const Form = ({ isOpen }) => {
  const { id } = useParams();
  const formik = useFormikContext();
  const { data: formDropDownList, isPending } = useFetch(
    ['getFormsByWorkflowId'],
    workflow.getFormsByWorkflowId(id)
  );
  return (
    <form
      className="formCont"
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <Select
        placeholder="Select form"
        name="formId"
        value={formik.values.formId}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.formId}
        touched={formik.touched.formId}
        options={formDropDownList?.data}
        isLoading={isPending}
      />
      <div className={styles.border}></div>
      <FormPreview formId={formik.values.formId} key={isOpen}  />
    </form>
  );
};

export default Form;
